/**
 * ч.1436: обробка 1С у консолі платформи — вихідні тексти і готовий файл (лише власник).
 */
import { api } from './client';
import { saveBlob } from '@/shared/utils/download';

export interface Migration1cFile { file_name: string; size: number; updated_at: string }

export interface WaitlistUser {
  email: string; full_name: string; tenant_name: string | null; telegram: boolean;
  created_at: string; notified_at: string | null; notified_via: 'telegram' | 'email' | null;
}
export interface WaitlistVariant {
  variant: 'bas' | 'managed' | 'bp20'; label: string; waiting: number; notified: number; users: WaitlistUser[];
}

export const platformMigration1c = {
  overview: () =>
    api.get<{ processing: Migration1cFile | null; files: Migration1cFile[] }>('/platform/migration-1c')
      .then((r) => r.data),
  downloadSource: async (name: string) => {
    const r = await api.get<Blob>(`/platform/migration-1c/files/${encodeURIComponent(name)}`, { responseType: 'blob' });
    saveBlob(r.data, name);
  },
  downloadProcessing: async (name: string) => {
    const r = await api.get<Blob>('/platform/migration-1c/processing', { responseType: 'blob' });
    saveBlob(r.data, name);
  },
  /** ч.1436: перелік очікувачів обробки, якої ще немає. */
  waitlist: () =>
    api.get<{ variants: WaitlistVariant[] }>('/platform/migration-1c/waitlist').then((r) => r.data.variants),
  notifyWaitlist: (variant: WaitlistVariant['variant']) =>
    api.post<{ telegram: number; email: number; failed: number }>('/platform/migration-1c/waitlist/notify', { variant })
      .then((r) => r.data),
};
